import React from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft, FaTimesCircle } from "react-icons/fa";

const Cancel = () => {
  return (
    <div className="min-h-[calc(100vh-90px)] bg-mmPage flex flex-col items-center justify-center text-center px-6 py-16">
      <div className="bg-mmSurface border border-red-500/70 px-8 py-10 rounded-2xl shadow-sm max-w-md w-full">
        <div className="flex justify-center mb-4">
          <FaTimesCircle className="text-red-500 text-5xl" />
        </div>
        <h1 className="text-mmText text-2xl font-display uppercase tracking-widest mb-4">
          Betaling geannuleerd
        </h1>
        <p className="text-mmTextMuted leading-relaxed mb-6 text-base md:text-lg">
          Je kunt het later opnieuw proberen.
        </p>

        <Link to="/pricing" className="mm-btnPrimary gap-2">
          <FaArrowLeft />
          Terug naar aanbod
        </Link>
      </div>
    </div>
  );
};

export default Cancel;
